export const notifications = [
    {
        id: 'e1de5d5e-2847-4c10-8d7b-cbf06f5b1de5',
        sender: 'אליס כהן',
        text: 'שלום, אשמח לקבל עוד מידע על הפרויקט שלכם.',
    },
    {
        id: '1f43b65d-51c7-4eab-9181-4eaf11a6f9ad',
        sender: 'בובי כץ',
        text: 'זה מאוד מעניין, אבל אני חושב שצריך להתייחס גם לנושא הכסף.',
    },
    {
        id: '5e9b7a01-53a8-4f90-9a09-7f63d9130d2a',
        sender: 'דורית לוי',
        text: 'אני מצטערת, אבל לא יכולה להשתתף בפגישה הזו.',
    },
    {
        id: '8d031d1e-1f2b-431f-a8d7-950e1010b6e9',
        sender: 'טום סמית',
        text: 'מה הולך, משהו חדש בחברה?',
    },
    {
        id: 'ebbf5a8a-cb21-4439-b25d-9607c61d05b6',
        sender: 'סמדר כהן',
        text: 'כן, התחלנו לפתח מוצר חדש וצריכים תמיכה טכנית.',
    },
    {
        id: 'b2cb9d56-80c3-4b5c-9905-5df5c508d2fb',
        sender: 'ישראל בן-שמעון',
        text: 'אני יכול לעזור לכם עם זה, אם תרצו.',
    },
]

export const requestsMock = [
    {
        _id: 'cf7c2aa9-1d7c-498e-9f7b-54a8f7a01f61',
        name: 'משה ישראלי',
        approvalDate: '12/03/23',
    },
    {
        _id: 'a17d3b70-9a9a-4d2b-b3d2-2257ebe29a01',
        name: 'גילי לוי',
        approvalDate: '05/02/23',
    },
    {
        _id: 'df232e20-17d5-45e3-b9f9-2f3d3d3133c3',
        name: 'אורן כהן',
        approvalDate: '22/01/23',
    },
    {
        _id: 'dbb8a20b-1c7d-4aa2-9e8e-54c125d7d18f',
        name: 'רוני כהן',
        approvalDate: '17/03/23',
    },
    {
        _id: '41e3c72d-492e-4dc3-bd5f-c4f4e8696a81',
        name: 'דני כהן',
        approvalDate: '01/03/23',
    },
    {
        _id: '86f2cc24-3e3b-44b2-8a54-7077cfaef15b',
        name: 'אבי רוזנבלט',
        approvalDate: '07/02/23',
    },
    {
        _id: 'a7d5582a-fce9-4e51-a6c2-48b4d4b4ba4f',
        name: 'דורית כהן',
        approvalDate: '18/02/23',
    },
    {
        _id: '3dd3c92f-03b9-4b10-91fb-cd23f64a37b2',
        name: 'יוסי גולדברג',
        approvalDate: '04/02/23',
    },
    {
        _id: 'd99a1b47-4642-4f80-9c29-50ebf12a8c84',
        name: 'רוית כהן',
        approvalDate: '09/03/23',
    },
    {
        _id: 'c64d4c2c-6774-4b4c-8e5d-cdd5a5a81a5c',
        name: 'טל ישראלי',
        approvalDate: '28/01/23',
    },
]

export const requestsStatusMock = {
    requests_approved: 512,
    requests_pending: 32,
    requests_unhandled: 10,
}
